<script lang="ts">
import ListTable from '../../list/Table.vue'
import mapPopup from './map-popup.vue'

export default {
    name: 'MapTooltip',
    components: { ListTable },
    extends: mapPopup,
    data() {
        return {
            sheet: false,
        }
    },
}
</script>

<template>
    <v-expand-transition v-show="sheet">
        <v-card
            class="py-2 px-4 text-center position-absolute"
            style="bottom:0; z-index:1000; pointer-events: none"
            width="100%"
        >
            <ListTable
                v-if="translationName"
                ref="table"
                :style="{ visibility: sheet ? 'visible' : 'hidden' }"
                density="compact"
                permission-name=""
                :permission-skip="true"
                :translation-name
                :sortable="[]"
                :no-action="true"
                :columns
                :data="features.map(feature => feature.getProperties())"
            />
            <!-- :click-columns="columns.map(col => col.dataKey)" -->
            <!-- @click-column="clickColumn($event)" -->
        </v-card>
    </v-expand-transition>
</template>

<style>
/* #map-declarations-tooltip .v-bottom-navigation__content {
    display: block !important;
} */

/* #map-declarations-tooltip .v-table {
    height: 115px !important;
} */
</style>
